import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const checkedIconComponent = {
  root: 'checked-icon.root',
} as const satisfies ComponentLocatorMap;
